<template>
    <div>
        <vue-perfect-scrollbar style="height: 408px" :settings="settings">
            <v-list two-line class="card-list">
                <template v-for="(request, index) in dashboard_work_orders">
                    <v-list-tile :key="index" class="clickable" @click="$router.push({ name: 'work_order', params: { id: request.id } })">
                        <v-list-tile-content>
                            <v-list-tile-sub-title>
                                <h5 class="mb-1">{{ request.wo_number }}</h5>
                                <v-list-tile-action-text class="fw-light">
                                    {{ request.company }}
                                </v-list-tile-action-text>
                            </v-list-tile-sub-title>
                            <p class="mb-0 fs-12 grey--text">
                                {{ request.content }}
                            </p>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-badge v-if="request.status.slug == 'new_request'" class="primary">In Progress</v-badge>
                            <v-badge v-else class="info">Closed</v-badge>
                        </v-list-tile-action>
                    </v-list-tile>
                </template>
            </v-list>
        </vue-perfect-scrollbar>
        <app-section-loader :status="loader"></app-section-loader>
    </div>
</template>
<script>
import api from "Api";
import { mapState, mapActions } from "vuex";
import AppSectionLoader from "Components/AppSectionLoader/AppSectionLoader";

export default {
    data() {
        return {
            loader: false,
            settings: {
                maxScrollbarLength: 160,
            },
        };
    },
    computed: {
        ...mapState({
            dashboard_work_orders: (state) => state.work_orders.dashboard_work_orders,
            work_orders: (state) => state.work_orders.work_orders,
        }),
    },
    mounted() {
        this.getWorkOrders();
    },
    methods: {
        ...mapActions(["fetchWorkOrders"]),
        getWorkOrders(refresh = false) {
            this.loader = true;
            this.$store.commit("mutate", {
                property: "dashboard_work_orders",
                with: [],
            });
            this.fetchWorkOrders({
                body: {
                    status: "new_request",
                    dashboard: true,
                    options: 1,
                },
            }).then((data) => {
                this.$store.commit("mutate", {
                    property: "dashboard_work_orders",
                    with: data.work_orders,
                });
                this.loader = false;
            });
        },
    },
    components: {
        AppSectionLoader,
    },
};
</script>
